import type { AppLang, I18nConstants } from './i18n.factory';

export async function createI18nAsync(lang: AppLang): Promise<I18nConstants> {
  const factoryPromise = import('./i18n.factory');

  switch (lang) {
    case 'en': {
      const [{ createI18nConstants }, { en }] = await Promise.all([
        factoryPromise,
        import('./en'),
      ]);
      return createI18nConstants(en);
    }
    case 'fr': {
      const [{ createI18nConstants }, { fr }] = await Promise.all([
        factoryPromise,
        import('./fr'),
      ]);
      return createI18nConstants(fr as any);
    }
    case 'ru': {
      const [{ createI18nConstants }, { ru }] = await Promise.all([
        factoryPromise,
        import('./ru'),
      ]);
      return createI18nConstants(ru as any);
    }
    case 'he':
    default: {
      const [{ createI18nConstants }, { he }] = await Promise.all([
        factoryPromise,
        import('./he'),
      ]);
      return createI18nConstants(he);
    }
  }
}
